import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { publicApi } from "../../lib/publicApi";
import FormDocument from "../../components/FormDocument";
import SignaturePad from "../../components/SignaturePad";
import { splitIds } from "../KioskFormPage";

import { tr, trServer } from "../../lib/i18n";
/** One-time customer link: shows only this form. Bilingual, no staff navigation. */
export default function PublicFormPage() {
  const { token } = useParams();
  const [view, setView] = useState(null);
  const [err, setErr] = useState("");
  const [vals, setVals] = useState({});
  const [masked, setMasked] = useState({});
  const [sig, setSig] = useState(null);
  const [done, setDone] = useState(false);
  useEffect(() => {
    publicApi.get(`/forms/${token}`).then(({ data }) => { const [v, m] = splitIds(data.data); setView(data); setVals(v); setMasked(m); })
      .catch(() => setErr(tr("x.this_link_has_expired_or_was_already_use")));
  }, [token]);
  const submit = async () => {
    try {
      const fields = Object.fromEntries((view.fillable || []).filter((k) => vals[k]).map((k) => [k, vals[k]]));
      await publicApi.post(`/forms/${token}/sign`, { signature: sig, fields });
      setDone(true);
    } catch (e) { setErr(e?.response?.data?.detail ? trServer(e.response.data.detail) : tr("x.could_not_sign_please_try_again")); }
  };
  const editable = Object.fromEntries((view?.fillable || []).map((k) => [k, true]));
  return (
    <div className="min-h-screen p-4 sm:p-8" style={{ background: "#f4f3f1" }} data-testid="public-form-page">
      <div className="max-w-4xl mx-auto space-y-4">
        {err && <div className="panel text-center" style={{ padding: 32 }} role="alert" data-testid="public-form-error">{err}</div>}
        {done && <div className="panel text-center text-xl" style={{ padding: 40 }} data-testid="public-form-thanks">{tr("x.thank_you_the_form_is_signed")}<div dir="rtl" className="mt-2">شكراً لك. تم توقيع النموذج.</div></div>}
        {view && !done && <>
          <FormDocument form={view} showroom={view.showroom} editable={editable} values={vals} onChange={(k, v) => setVals({ ...vals, [k]: v })} placeholders={masked} hideSignatures />
          <div className="panel" style={{ padding: 16 }}>
            <SignaturePad label={tr("x.sign_here")} onChange={setSig} testid="public-form-pad" />
            <button data-testid="public-form-submit" className="btn-primary h-12 px-6 mt-3 w-full" disabled={!sig} onClick={submit}>{tr("x.sign_and_submit")}</button>
          </div>
        </>}
      </div>
    </div>
  );
}
